import React, { useEffect, useMemo } from "react";
import WebsiteHeader from "./header";
import WebsiteFooter from "./footer";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { addData } from "../../../redux/slices/globalDetails";
import { GlobalSettingsDetails } from "../services/website.services";
import "../../../assets/website/css/custom.css";

function WebsiteLayout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  window.navigate_ = navigate;

  useEffect(() => {
    const previousBodyClass = document.body.className;
    const previousOverflow = document.body.style.overflow;

    // Admin layout adds body classes that break website styling.
    document.body.className = "";
    document.body.style.overflow = "";

    return () => {
      document.body.className = previousBodyClass;
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  useEffect(() => {
    GlobalSettingsDetails().then(async (globalDetails) => {
      dispatch(addData(globalDetails?.data));
      setTimeout(() => {
        dispatch(setGlobalLoader(false));
      }, 100);
    });
  }, [dispatch]);

  return (
    <div className="site-wraper-main">
      <WebsiteHeader />
      <div className="site-wraper light min-h-screen bg-bg px-6 sm:px-10 lg:px-16">
        <div className="inner-wraper">
          <Outlet />
        </div>
      </div>
      <WebsiteFooter />
    </div>
  );
}

export default WebsiteLayout;
